import { environmentHttpClient } from "client/Api/httpClient";
import { SecretValue } from "client/Api/Apps/common";

export enum MagisterApiVersion {
	V1 = 1
}

export type MagisterConnectionModel = {
	id: number;
	name: string;
	serverUrl: string;
	username: string;
	apiVersion: MagisterApiVersion;
};

export type MagisterConnectionListItemModel = {
	id: number;
	name: string;
	serverUrl: string;
};

export type MagisterConnectionSaveModel = {
	name: string;
	serverUrl: string;
	username: string;
	password: SecretValue;
	apiVersion: MagisterApiVersion;
};

export type NewConnectionMagisterSaveResultModel = {
	connectionId: number;
};

export function list(
	signal?: AbortSignal
): Promise<readonly MagisterConnectionListItemModel[]> {
	return environmentHttpClient.get<readonly MagisterConnectionListItemModel[]>(
		"UiApi/MagisterConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<MagisterConnectionModel> {
	return environmentHttpClient.get<MagisterConnectionModel>(
		`UiApi/MagisterConfiguration/${id}`,
		undefined,
		{
			signal
		}
	);
}

export function create(
	model: MagisterConnectionSaveModel,
	signal?: AbortSignal
): Promise<NewConnectionMagisterSaveResultModel> {
	return environmentHttpClient.post<NewConnectionMagisterSaveResultModel>(
		"UiApi/MagisterConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: MagisterConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`UiApi/MagisterConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteMultiple(
	ids: readonly number[],
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/MagisterConfiguration",
		ids,
		{ signal }
	);
}
